import { createContext, useContext } from "react";

/** Default public class/id prefix. Keeps existing `tomis-chat-*` strings. */
export const DEFAULT_CLASS_PREFIX = "tomis";

export const ClassPrefixContext = createContext(DEFAULT_CLASS_PREFIX);

export function useClassPrefix(): string {
  return useContext(ClassPrefixContext);
}

/**
 * Shadow-DOM class names follow the agency namespace.
 *
 * `chatClass("header")` → `${prefix}-chat-header`
 */
export function useChatClass(): (...parts: Array<string | number>) => string {
  const prefix = useClassPrefix();
  return (...parts) => [prefix, "chat", ...parts].join("-");
}
